export default __webpack_public_path__ + "static/media/gcp.dade32d4.png";